module.exports = __webpack_public_path__ + "static/media/trashIcon.182fc384.svg";